<template>
  <div class="m-portlet__head">
    <div class="m-portlet__head-progress">
      <!-- here can place a progress bar-->
    </div>
    <div class="m-portlet__head-wrapper">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">{{label}}<span v-if="label2 != '' && label2 != null" style="padding-left:5px;">|</span><span style="padding-left:5px;">{{label2}}</span></h3>
        </div>
        <span v-if="label3 != '' && label3 != null" style="margin-left: 50px;" class="m--font-warning">{{label3}}</span>
      </div>
      <div class="m-portlet__head-tools">
        <el-button @click="Back()" v-if="this.url != null">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHead',
  props: {
    label: {
      type: String
    },
    label2: {
      type: String
    },
    label3: {
      type: String
    },
    url: {
      type: String
    }
  },
  methods: {
    Back: function () {
      this.$router.push('/main' + this.url)
    }
  }
}
</script>

<style scoped="scoped">
  .el-table--medium td, .el-table--medium th {
      padding: 6px 0;
  }
  .el-table .cell {
      line-height: 36px;
  }
</style>
